<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	
	
	import HelloWorld from './components/HelloWorld.vue'
	import './vendors/feather/feather.min.js'
	
	export default {
		name: 'app',
		components: {
			
		},
		created() {

		},
		beforeunload(){
			var ca = document.cookie.split("user_token=")[1];
			console.log(ca)
			this.$message.success(ca)
			var d = new Date();
			d.setTime(d.getTime() + (-1 * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = "user_token="+'' + "; " + expires;;
			document.cookie = "user="+'' + "; " + expires;;
			document.cookie = "ASP.NET_SessionId="+'' + "; " + expires;;
		}
	}
</script>

<style>
	.a .el-breadcrumb__inner {
		color: #0081ff !important;
		font-weight: 700 !important;
	}
	#app{
		min-width: 1300px;
		width:expression(document.body.clientWidth < 600? "600px": "auto" )
	}
	*{
		font-size: 12px !important;
	}
</style>
